<template>
    <div class="content-expand" :class="{'is-content-expaned': expanded}">
        <div class="content-expand__content" :style="{'height': height}">
            <div class="content-expand__content__inner" ref="content">
                <slot/>
            </div>
        </div>
        <div class="content-expand__toggle ui-center-vertically" @click="toggle" v-if="initialized">
            <div class="content-expand__toggle__text">{{ expanded ? lessText : moreText }}</div>
            <icon class="content-expand__toggle__icon" :size="20"><IconChevronDown /></icon>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/Icon.vue'
import IconChevronDown from '@/components/icons/IconChevronDown.vue'
import eventBus from '@/utils/event-bus';
export default {
    components: {
        Icon,
        IconChevronDown,
    },
    props: {
        collapsedHeight: {
            type: String,
            default: '75px'
        },
        moreText: {
            type: String,
            default: 'Mehr anzeigen',
        },
        lessText: {
            type: String,
            default: 'Weniger anzeigen',
        }
    },
    data() {
        return {
            expanded: false,
            height: 'auto',
            initialized: false,
        }
    },
    mounted() {
        this.initializeSwitch();
    },
    methods: {
        toggle() {
            if(this.expanded) {
                this.height = this.collapsedHeight;
            } else {
                this.height = this.$refs['content'].clientHeight + 'px';
            }
            this.expanded = !this.expanded;
            eventBus.$emit('collapsed',  {target: this.$refs['content'].clientHeight, expanded: this.expanded});
        },
        initializeSwitch() {
            if(this.$refs['content'].clientHeight > parseInt(this.collapsedHeight) || this.$refs['content'].clientHeight === 0) {
                this.height = this.collapsedHeight;
                this.initialized = true;
            }
        }
    }
}
</script>

<style lang="scss">
    .content-expand {
        $block: &;
        &__content {
            transition: height 0.4s $ease-out-quart;
            height: 5em;
            overflow: hidden;
            &:not(:last-child) {
                margin-bottom: 8px;
            }
        }
        &__toggle {
            cursor: pointer;
            &__text {
                margin-right: 0.3em;
            }
            &__icon {
                transition: transform 0.4s $ease-out-quart;
                .is-content-expaned & {
                    transform: rotate(180deg);
                }
            }
        }
    }
</style>